import { Flex, Icon, Image, Skeleton } from '@chakra-ui/react';
import { useStakedNfts } from '@ui/hooks/useCruisers';
import type { GardenType } from '@ui/utils/garden';
import { ColorThemeVars } from '@veno-app/chakra';
import { NftSlot } from '@veno-app/icons';
import React from 'react';

type GardenNftOverviewProps = {
  gardenType: GardenType;
};

function GardenNftOverview({ gardenType }: GardenNftOverviewProps) {
  const { data: nfts } = useStakedNfts(gardenType);

  return (
    <Flex>
      <>
        {Array.from({ length: 5 }).map((_, i) => (
          <Flex
            bg={`var(${ColorThemeVars.mainColorLight})`}
            rounded="5px"
            borderColor="brand-primary"
            borderWidth="1px"
            borderStyle="dashed"
            order={i}
            key={i}
            w="45px"
            h="45px"
            mr={i <= 3 ? '-33px' : 0}
            justify="center"
            align="center"
            _dark={{
              bg: `var(${ColorThemeVars.mainColor})`,
              borderColor: 'brand-blue',
            }}
          >
            {i === 4 && !nfts?.length && (
              <Skeleton isLoaded={!!nfts}>
                <Icon
                  as={NftSlot}
                  display="block"
                  w="17px"
                  h="27px"
                  color="brand-primary"
                  _dark={{
                    color: 'brand-blue',
                  }}
                />
              </Skeleton>
            )}
            {nfts && (nfts?.length ?? 0) > 4 - i && (
              <Image
                rounded="5px"
                w="full"
                h="full"
                src={nfts[4 - i].image.url}
                alt={nfts[4 - i].name}
              />
            )}
          </Flex>
        ))}
      </>
    </Flex>
  );
}

export default GardenNftOverview;
